import { useQuery } from '@apollo/client';

import GetMastertrackBySlugForPromotionBanner from 'bundles/promotions/queries/GetMastertrackBySlugForPromotionBannerQuery.graphql';
import type {
  GetMastertrackBySlugForPromotionBannerQuery,
  GetMastertrackBySlugForPromotionBannerQueryVariables,
  MastertrackFragment as Mastertrack,
} from 'bundles/promotions/queries/__generated__/GetMastertrackBySlugForPromotionBannerQuery';

export type PropsFromUseGetMastertracksBySlug = {
  masterTrack?: Mastertrack;
};

export const useGetMastertracksBySlug = ({
  masterTrackSlug,
  skip = false,
}: {
  masterTrackSlug?: string | null;
  skip?: boolean;
}) => {
  const { data } = useQuery<
    GetMastertrackBySlugForPromotionBannerQuery,
    GetMastertrackBySlugForPromotionBannerQueryVariables
  >(GetMastertrackBySlugForPromotionBanner, {
    variables: { slug: `${masterTrackSlug}` },
    skip: skip || !masterTrackSlug,
    context: { clientName: 'gatewayGql' },
  });

  return {
    masterTrack: data?.Degree?.queryBySlug ?? undefined,
  };
};
